import { yupResolver } from '@hookform/resolvers/yup';
import { DialogContent, DialogTitle, Grid, Stack } from '@mui/material';
import { useState } from 'react';
import { FieldValues, FormProvider, useForm } from 'react-hook-form';
import { CiCircleInfo } from 'react-icons/ci';
import { ICandidate, saveCandidate } from 'wisestep-api';
import { WsDialog, Item, WsButton, WsColors, WsIconText } from 'wisestep-base';
import { object } from 'yup';

import { CandidateDetails, getTabs, getValidationSchema } from '../../utils/MergeCandidateHelper';

interface MergeCandidateProps {
  open: boolean;
  onClose: () => void;
  candidate: ICandidate;
  mergeCandidate: ICandidate;
  fields: string[];
}

const MergeCandidate = ({
  open,
  onClose,
  candidate,
  mergeCandidate,
  fields = [],
}: MergeCandidateProps) => {
  const [step, setStep] = useState<number>(0);
  const tabs = getTabs(fields, candidate);
  const totalSteps = tabs.length;
  const [schema, defaultValues] = getValidationSchema(candidate, fields);
  const methods = useForm({
    defaultValues: defaultValues,
    resolver: yupResolver(object().shape(schema)),
  });
  const { handleSubmit } = methods;
  const onFormSubmit = async (data: FieldValues) => {
    const candidate = { ...mergeCandidate };

    if (data?.email && data.email.length > 0) {
      candidate.email = data.email[0];
      candidate.alternateEmails = data.email.filter((email) => email !== candidate.email);
    }
    if (data?.currentSalaryObj) {
      const currentSalary = JSON.parse(data?.currentSalaryObj);
      candidate.currentSalary = currentSalary?.salary;
      candidate.currentSalaryCurrency = currentSalary?.salaryCurrency;
      candidate.currentSalaryTimeSpan = currentSalary?.salaryTimeSpan;
    }
    if (data?.expectedSalaryObj) {
      const expectedSalary = JSON.parse(data.expectedSalaryObj);
      candidate.expectedBaseSalary = expectedSalary.salary;
      candidate.expectedSalaryCurrency = expectedSalary.salaryCurrency;
      candidate.expectedBaseSalaryTimeSpan = expectedSalary.salaryTimeSpan;
    }

    if (data.currentLocationObj) {
      candidate.currentLocation = JSON.parse(data.currentLocationObj);
    }
    if (data.citizenshipArr) {
      candidate.citizenship = data.citizenshipArr.split(',');
    }
    if (data.dob) {
      candidate.dob = data.dob;
    }
    if (data.nationality) {
      candidate.nationality = data.nationality;
    }
    if (data.passportType) {
      candidate.passportType = data.passportType;
    }
    if (data.passportNumber) {
      candidate.passportNumber = data.passportNumber;
    }
    if (data.willingToRelocate) {
      candidate.willingToRelocate = data.willingToRelocate === 'YES';
    }
    if (data.passportNumber) {
      candidate.willingToTravel = data.willingToTravel === 'YES';
    }
    if (data.willingToTravelType) {
      candidate.willingToTravelType = data.willingToTravelType;
    }
    await saveCandidate(candidate as ICandidate);
    window.location.reload();
  };

  return (
    <FormProvider {...methods}>
      <form>
        <WsDialog openDialog={open} size={'medium'} onClose={onClose}>
          <DialogTitle>Merge Profiles</DialogTitle>
          <DialogContent
            sx={{
              bgcolor: WsColors.BorderGrey,
              px: 0,
              py: 0,
            }}
          >
            <Grid container sx={{ bgcolor: WsColors.BorderGrey }} mt={0} borderRadius={1}>
              <Grid item xs={12} p={3} bgcolor={WsColors.BorderGrey}>
                <Grid container direction="row" sx={{ bgcolor: WsColors.BorderGrey }} spacing={1}>
                  <Grid item xs={12} p={1} ml={2}>
                    <WsIconText
                      text={
                        'Only 3 Emails and Phone numbers can be selected. Unselected details will be deleted'
                      }
                      icon={<CiCircleInfo size={20} />}
                      onClick={() => {}}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <CandidateDetails candidate={candidate} fields={fields} step={tabs[step]} />
                  </Grid>
                  <Grid item xs={6}>
                    <CandidateDetails
                      candidate={mergeCandidate}
                      fields={fields}
                      step={tabs[step]}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </DialogContent>
          <Grid container item xs={12} justifyContent="flex-end">
            <Item>
              <Stack direction="row" spacing={2}>
                <WsButton
                  variant="outlined"
                  onClick={() => setStep(step - 1)}
                  disabled={step === 0}
                >
                  Prev
                </WsButton>
                <WsButton
                  variant="outlined"
                  onClick={() => setStep(step + 1)}
                  disabled={step === totalSteps - 1}
                >
                  Next
                </WsButton>
                <WsButton
                  type="button"
                  onClick={handleSubmit(onFormSubmit)}
                  disabled={step !== totalSteps - 1}
                >
                  Save
                </WsButton>
              </Stack>
            </Item>
          </Grid>
        </WsDialog>
      </form>
    </FormProvider>
  );
};

export default MergeCandidate;
